import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "react-bootstrap-table-next";
import Button from "components/CustomButtons/Button.jsx";
import Modal from "react-bootstrap/Modal";

import { getCompressor, deleteCompressor } from "../../../rest/compressor"

class ListCompressor extends React.Component {

  state = {
	profileInfo: JSON.parse(window.localStorage.getItem("profileInfo")),
    compressorData: [],
    showModal: false
  };

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    await this.fetchCompressor();
  }

  fetchCompressor = async() => {
    try{
      let res = await getCompressor();
	  let compData = res.data.filter((cur) => {
        return this.state.profileInfo.accessItems[0].c != undefined ? this.state.profileInfo.accessItems[0].c.includes(cur.name) : this.state.profileInfo.accessItems[0].compressors.includes(cur.name);
      }, this);
      this.setState({
        compressorData: compData
      })
    } catch (e){
      console.log(e);
    }
  }

  nameFormatter = (cell, row) => {
    return (
      <span className="hyperlink" onClick={() => { this.props.history.push(`/admin/updatecompressors/${row.id}`)}}>{cell}</span>
    );
  }

  deleteFormatter = (cell, row) => {
    return (
        <div className="text-center">
            <span className="fa fa-trash text-center" onClick={() => { this.openModal(cell)}}></span>
        </div>    
    );
  }

  navToDetails = () => {
    this.props.history.push(`/admin/updatecompressors/0`);
  }

  openModal = (id) => {
    this.setState({
        showModal: true,
        compressorId: id
      });
  }

  hideModal = () => {
      this.setState({
          showModal: false
      });
  }

  deleteCompressor = async() => {
    try {
      await deleteCompressor(this.state.compressorId);
      this.setState({
          showModal: false,
          compressorId: ""
      }, async () => {
          alert("Compressor Deleted Successfully");
          await this.fetchCompressor();
      });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const tableColDef = [{
      dataField: 'name',
      text: 'Name',
      formatter: this.nameFormatter
    }, {
      dataField: 'site_name',
      text: 'Site Name',
    }, {
      dataField: 'location',
      text: 'Location',
    }, {
      dataField: 'phone',
      text: 'Phone',
    }, {
      dataField: 'status',
      text: 'Status',
    }, {
      dataField: 'active',
      text: 'Active',
    }];

    return (
      <div>
        <Card>
          <CardHeader color="primary">
            <h4><b>Update Compressors</b></h4>
          </CardHeader>
          <CardBody>
            <GridContainer>                
              <GridItem sm={12} md={12}>
                <Table keyField="name"
                  data={this.state.compressorData}
                  columns={tableColDef}
                  noDataIndication="No Compressors Available"/>  
              </GridItem>
            </GridContainer>  
          </CardBody>  
        </Card>        
      </div>
    );
  }
}

export default ListCompressor;